import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostSwitchOrganizationRequest = {
	organizationId: number;
};

export type PostSwitchOrganizationResponse = {
	token: string;
};

export const postSwitchOrganization = createPostEndpoint<
	PostSwitchOrganizationRequest,
	PostSwitchOrganizationResponse
>(
	(request) => `/api/v3/security/authentication/switch-organization/${request.organizationId}`
);
